var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4961 21.6113H36.5039C37.6641 21.6113 38.6133 20.6622 38.6133 19.502C38.6133 18.3418 37.6641 17.3926 36.5039 17.3926H23.4961C22.3359 17.3926 21.3867 18.3417 21.3867 19.502C21.3867 20.6622 22.3359 21.6113 23.4961 21.6113Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9453 30.2461H44.8247C44.2422 30.2461 43.77 30.7183 43.77 31.3008V40.582C43.77 41.1645 44.2422 41.6367 44.8247 41.6367H46.9453C47.5277 41.6367 47.9999 41.1645 47.9999 40.582V31.3008C47.9999 30.7183 47.5277 30.2461 46.9453 30.2461Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8906 23.7207H32.1094V26.2162H27.8906V23.7207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1752 30.2461H13.0547C12.4722 30.2461 12 30.7183 12 31.3008V40.582C12 41.1645 12.4722 41.6367 13.0547 41.6367H15.1752C15.7577 41.6367 16.2299 41.1645 16.2299 40.582V31.3008C16.2299 30.7183 15.7578 30.2461 15.1752 30.2461Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5704 30.1395V28.3262H25.4297V30.1395C24.3427 30.5833 23.3943 31.1813 22.6402 31.8994H18.3394V39.9853H22.6401C24.3721 41.6355 27.0819 42.6088 30 42.6088C32.9181 42.6088 35.628 41.6355 37.3599 39.9853H41.6607V31.8994H37.3599C36.6059 31.1813 35.6575 30.5832 34.5704 30.1395Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon_01.f1eadc56de206e23f970455a4de9a231.svg";
export { ForwardRef as ReactComponent };